<template>
  <section class="ttn-file-type">
    <ttn-filters
      :hidden="!!response"
      @reset="handleReset"
      @back="response = undefined"
      @searched="searched = true"
    />
    <ttn-responses v-if="searched" v-show="!response" @set="setResponse" />
    <chosen-response v-if="response" :item="response" :type="type" />
  </section>
</template>

<script>
import ChosenResponse from './ChosenResponse'
import TtnFilters from './TtnFilters'
import TtnResponses from './TtnResponses'

export default {
  name: 'TtnFileType',
  components: { TtnFilters, TtnResponses, ChosenResponse },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searched: false,
      response: undefined,
    }
  },
  methods: {
    setResponse(item) {
      this.response = item
    },
    handleReset() {
      this.response = undefined
      this.searched = false
    },
  },
}
</script>
